import { render, staticRenderFns } from "./SubgroupUsers.vue?vue&type=template&id=22bada27"
import script from "./SubgroupUsers.vue?vue&type=script&lang=js"
export * from "./SubgroupUsers.vue?vue&type=script&lang=js"
import style0 from "./SubgroupUsers.vue?vue&type=style&index=0&id=22bada27&prod&lang=css"
import style1 from "./SubgroupUsers.vue?vue&type=style&index=1&id=22bada27&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports